import { render, staticRenderFns } from "./OrgReg.vue?vue&type=template&id=32e48d5f"
import script from "./OrgReg.vue?vue&type=script&lang=js"
export * from "./OrgReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports